/**
 * SpaceModeBadge — shows the current MSPACE / PSPACE / MSPACE_VIA_VP mode.
 * AutoCAD parity: the MODEL/PAPER toggle button in the status bar.
 * Phase MC1 wire-up; click interaction for MSPACE_VIA_VP exit is MC3.
 */

import {
  useSpaceContextStore,
  type SpaceContextMode,
} from "../../state/spaceContextStore";
import { useT, type MessageKey } from "../../i18n";

const MODE_KEYS: Record<SpaceContextMode, MessageKey> = {
  MSPACE: "space.mode_badge.mspace",
  PSPACE: "space.mode_badge.pspace",
  MSPACE_VIA_VP: "space.mode_badge.mspace_via_vp",
};

export function SpaceModeBadge() {
  const t = useT();
  const mode = useSpaceContextStore((s) => s.mode);
  return (
    <span
      className={`space-mode-badge space-mode-badge--${mode.toLowerCase().replace(/_/g, "-")}`}
      data-testid="space-mode-badge"
      title={mode}
    >
      {t(MODE_KEYS[mode])}
    </span>
  );
}
